module.exports = __webpack_public_path__ + "img/card.221d6e50.svg";